import BaseService from "./geral/BaseService";
import {urlApi} from "../config/Constantes";

const base = "Sailing";

export default class SailingBreakdownService extends BaseService {
    constructor() {
        super(base);
    }

    listarOperacoes (dataInicial, dataFinal){
        return super.httpGet(`/${base}/ListarOperacoes?dataInicial=${dataInicial}&dataFinal=${dataFinal}&tamanhoPagina=${this.tamanhoPagina}`);
    }

    relatorio (operacao){
        return `${urlApi}/${base}/Relatorio/${operacao}`
    }
}


// WEBPACK FOOTER //
// ./src/services/SailingBreakdownService.js